/*global
    jQuery
*/
(function ($) {
    var showOrHideEditPhotoMenu = function(e) {
        var $this = $(this),
            menu = $this.siblings('ul.edit-photo-menu');
        if ( menu.is(':visible') ) {
            menu.fadeOut(50);
        } else {
            menu.fadeIn(50);
        }
        e.preventDefault();
    }
        function insertLoadingGraphic(elem) {
            $('body').append('<div class="loading-overlay"></div>');
        }

        function showLoadingGraphic(elem) {
            var loadingGraphic = $(document).find('div.loading-graphic');
               console.log('loading graphic?'); 
            setTimeout(function () {
                    //elem.parents('form').prop('disabled', true);
                    if (typeof loadingGraphic === 'undefined' || loadingGraphic.length == 0) {
                        insertLoadingGraphic(elem);
                    } else {
                        $(document).find('div.loading-overlay').css('display', 'block');
                    }
            }, 200);
        }

        function hideLoadingGraphic() {
            $('form').prop('disabled', false);
            $('div.loading-overlay').css('display', 'none');
        }


    var replacePhoto = function(e) {
        console.log('triggered?');
        var $this = $(this),
            $container = $this.parents('div.edit-gallery'),
            $form = $container.find('form.upload_photo_form'),
            rank = $form.find('input[name="rank"]').val(),
            pet_id = $form.find('input[name="pet_id"]').val(),
            $previewPhoto = $container.find('img.previewPhoto'),
            csrf_token = $form.find('input[name="_token"]').val(),
            formData = new FormData(),
            $fileUpload = $form.find('[type="file"]').get(0);

        // Add image from file upload field to formData object
        formData.append('photo_2_id', $fileUpload.files[0]);
        var xhr = $.ajax({
            url: '/pet/' + pet_id + '/replace_photo/' + rank,
            method: 'POST',
            dataType: 'json',
            contentType: 'false',
            data: formData,
            cache: false,
            headers:{
                'X-CSRF-TOKEN': csrf_token
            },
            processData: false
        });

        xhr.done(function(data) {
            if(typeof data !== 'undefined') {
                $.each(data, function (key, photoUrl) {
                    $previewPhoto.attr('src', photoUrl);
                    window.location.reload();
               hideLoadingGraphic($container);
                });
            } else {
                console.log('No data?');
               hideLoadingGraphic($container);
            }
        });

        e.preventDefault();
        $this.parent('ul').fadeOut(300);
    }

    var replacePhotoTwo = function(e) {
        e.preventDefault();
        var $this = $(this),
            $container = $this.parents('div.edit-gallery'),
            $form = $container.find('form.upload_photo_form'),
            rank = $form.find('input[name="rank"]').val(),
            pet_id = $form.find('input[name="pet_id"]').val(),
            $previewPhoto = $container.find('img.previewPhoto'),
            csrf_token = $form.find('input[name="_token"]').val(),
            formData = new FormData();

        // Add image from file upload field to formData object

    }

    var editFormSubmit = function(e) {
        e.preventDefault();
        $('ul.edit-photo-menu').hide();
        var $this = $(this),
            $container = $this.parents('div.edit-gallery'),
            $form = $container.find('form.upload_photo_form'),
            csrf_token = $form.find('input[name="_token"]').val(),
            rank = $form.find('input[name="rank"]').val(),
            pet_id = $form.find('input[name="pet_id"]').val(),
            $preview = $container.find('img.previewPhoto');
            fileSelect = document.getElementById('upload_photo_'+rank+'_field');

        var files = fileSelect.files;
        var formData = new FormData();

        var photo_field_name = 'photo_'+rank+'_id';
        formData.append(photo_field_name, files[0]);

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/pet/'+pet_id+'/replace_photo/'+rank, true);
        xhr.setRequestHeader('X-CSRF-TOKEN', csrf_token);
        showLoadingGraphic($container);
        xhr.onload = function() {
            if (xhr.status === 200) {
                var response = JSON.parse(xhr.responseText);
                var responseArray = $.map(response, function(el) { return el; });
                var d = new Date();
                $preview.attr('src',responseArray[0] + '?' + d.getTime());
            } else {
            }
            console.log('No data?');
            hideLoadingGraphic($container);
        }

        xhr.send(formData);
        $('ul.edit-photo-menu').fadeOut(300);
    }

    var deletePhoto = function(e) {
        var $this = $(this),
            $container = $this.parents('div.edit-gallery'),
            $form = $container.find('form.upload_photo_form'),
            csrf_token = $form.find('input[name="_token"]').val(),
            rank = $form.find('input[name="rank"]').val(),
            pet_id = $form.find('input[name="pet_id"]').val();

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/pet/'+pet_id+'/delete_photo/'+rank, true);
        showLoadingGraphic($container);
        xhr.setRequestHeader('X-CSRF-TOKEN', csrf_token);
        xhr.onload = function() {
            if (xhr.status === 200) {
                var response = JSON.parse(xhr.responseText);
                $container.remove();
                window.location.reload();
            } else {
            }
        }

        xhr.send();
        $this.parent('ul').fadeOut(300);
    }

    var promotePhoto = function(e) {
        var $this = $(this),
            $container = $this.parents('div.edit-gallery'),
            $form = $container.find('form.upload_photo_form'),
            csrf_token = $form.find('input[name="_token"]').val(),
            rank = $form.find('input[name="rank"]').val(),
            pet_id = $form.find('input[name="pet_id"]').val();

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/pet/'+pet_id+'/make_primary_photo/'+rank, true);
        xhr.setRequestHeader('X-CSRF-TOKEN', csrf_token);
        showLoadingGraphic($container);
        xhr.onload = function() {
            if (xhr.status === 200) {
                var response = JSON.parse(xhr.responseText);
                $container.parent().prepend($container);
                window.location.reload();
            } else {
            }
        }

        xhr.send();
        $this.parent('ul').fadeOut(300);
    }

    var tearDown = function () {
        $('button.edit-photo').off('click');
        $('li.replacePhoto').off('click');
        $('li.deletePhoto').off('click');
        $('li.makePrimary').off('click');
        $('input.edit_photo_field').off('change');
    }

    var initialize = function () {
        $('button.edit-photo').on('click', showOrHideEditPhotoMenu);
        $('li.replacePhoto').on('click', function() {
            var $this = $(this);
            $this.parents('form.upload_photo_form').find('input.edit_photo_field').trigger('click');
        });
        $('li.deletePhoto').on('click', deletePhoto);
        $('li.makePrimary').on('click', promotePhoto);
        $('input.edit_photo_field').on('change', editFormSubmit);
    }

    initialize();
}(jQuery));
